import { render, staticRenderFns } from "./barTotal.vue?vue&type=template&id=47f10370"
import script from "./barTotal.vue?vue&type=script&lang=js"
export * from "./barTotal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports